import type { IBootstrap } from './definitions'

/** A globális névtérben lévő bootstrap objectet adja vissza. */
export default function getBootstrapApi (): IBootstrap {
  return (window as unknown as { bootstrap: IBootstrap }).bootstrap
}
